import React from 'react';
import {withRouter} from 'react-router-dom';
import _ from 'lodash';
import { Toolbar, BackButton } from 'react-onsenui';
import './Toolbar.css';
import PropTypes from 'prop-types';
import ToolbarRightMenuButton from '../ToolbarRightMenuButton';

const Header = props => {
    return (
        <Toolbar modifier='ls_toolbar noshadow'>
            <div className="left">
                <BackButton 
                    onClick={() => {
                        if(props.back !== '' && props.back !== undefined && props.back !== null) {
                            props.history.push(props.back);
                        }
                        else if(props.close) {
                            window.postMessage(JSON.stringify({action: 'exit', parameters: {}}), '*');
                        }
                        else{
                            props.history.goBack();
                        }
                    }} 
                    modifier='quiet'
                >
                </BackButton>
            </div>
            <div className="center" style={{textTransform: 'uppercase', color: '#fff', textAlign: 'center', fontSize: '15px', fontFamily: 'fff-equipe'}}>{props.title}</div>
            <div className="right ls_contextual">
                {
                     _.isArray(props.settings) && props.settings.length > 0 && 
                    <ToolbarRightMenuButton settings={props.settings} />
                }
            </div>
        </Toolbar>
    );
}

Header.propTypes = {
    close: PropTypes.bool,
    history: PropTypes.object.isRequired,
    back: PropTypes.string,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    settings: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string,
        to: PropTypes.string,
        name: PropTypes.string
    }))
}

export default withRouter(Header);